import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from '@gatsbyjs/reach-router';
import { useConfiguration } from '@printdeal/configuration/react';
import { useFeatureToggle } from '@printdeal/feature-management/react';
import ChatProvider from './ChatProvider';
import { getLanguageFromLocale } from '../../../helpers/translations';
import { useAccount } from '../../../hooks/useAccount';
import { useCustomer } from '../../../hooks/useCustomer';

const Chat = ({ children }: { children: ReactNode }) => {
  const intl = useIntl();
  const locale = getLanguageFromLocale(intl.locale);
  const location = useLocation();
  const { account } = useAccount();
  const { customer } = useCustomer();
  const { featureToggle: { isEnabled: isChatEnabled } } = useFeatureToggle('chat_widget');
  const { chat: chatConfig } = useConfiguration();

  return (
    <ChatProvider
      locale={locale}
      identity={{ name: account?.firstName || '', email: customer?.email || '' }}
      locationHref={location.href}
      locationPathName={location.pathname}
      chatConfig={{
        ...chatConfig,
        enabled: Boolean(chatConfig.enabled && chatConfig.zendeskKey && chatConfig.channel && isChatEnabled),
      }}
    >
      {children}
    </ChatProvider>
  );
};

export default Chat;
